<template>
  <div id="app">
    <!-- <img src="./assets/logo.png"> -->
    <keep-alive>
      <!-- 可以被缓存的视图组件 -->
      <router-view v-if="$route.meta.keepAlive"></router-view>
    </keep-alive>
    <router-view v-if="!$route.meta.keepAlive"/>
  </div>
</template>

<script>
import{
  shareWx
} from './service/api'
export default {
  name: 'App',
  data() {
    return {
     
    }
  },
  mounted() {
    // shareWx({
    //       url: encodeURIComponent(location.href.split("#")[0])
    //     }).then(res => {
    //       wx.config({
    //         debug: false,
    //         appId: res.appId, // 必填，公众号的唯一标识
    //         timestamp: res.timestamp, // 必填，生成签名的时间戳
    //         nonceStr: res.nonceStr, // 必填，生成签名的随机串
    //         signature: res.signature, // 必填，签名
    //         signType: res.signType,
    //         jsApiList: ['onMenuShareTimeline', 'onMenuShareAppMessage', 'hideMenuItems'] // 必填，需要使用的JS接口列表
    //       })

    //       // wx.ready(function () {
    //       //   wx.onMenuShareTimeline({
    //       //     // wx.updateTimelineShareData({
    //       //     title: title, // 分享标题
    //       //     link: link, // 
    //       //     imgUrl: imgUrl, // 分享图标
    //       //     trigger: function (res) {
    //       //       // 不要尝试在trigger中使用ajax异步请求修改本次分享的内容，因为客户端分享操作是一个同步操作，这时候使用ajax的回包会还没有返回
    //       //       // alert('用户点击发送给朋友');
    //       //     },
    //       //     success: function (res) {
    //       //       // alert('已分享');
    //       //     },
    //       //     cancel: function (res) {
    //       //       // alert('已取消');
    //       //     },
    //       //     fail: function (res) {
    //       //       // alert(JSON.stringify(res));
    //       //     }
    //       //   })
    //       // })
    //       // //分享给朋友
    //       // wx.ready(function () { //需在用户可能点击分享按钮前就先调用
    //       //   wx.onMenuShareAppMessage({
    //       //     // wx.updateAppMessageShareData({
    //       //     title: title, // 分享标题
    //       //     desc: desc, // 分享描述
    //       //     link: link, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
    //       //     imgUrl: imgUrl, // 分享图标
    //       //     success: function (res) {
    //       //       // 用户点击了分享后执行的回调函数
    //       //     }
    //       //   });
    //       // });
    //       // wx.ready(function () {
    //       //   wx.hideMenuItems({
    //       //     menuList: ['menuItem:share:qq',
    //       //       'menuItem:share:QZone'
    //       //     ] // 要隐藏的菜单项，只能隐藏“传播类”和“保护类”按钮，所有menu项见附录3
    //       //   });
    //       // })
    //     })
    
  },
};
</script>
<style lang="stylus">
  @import './stylus/index.styl';

</style>
<style>
  #app {
    font-family: 'Avenir', Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: #2c3e50;
  }

</style>



// WEBPACK FOOTER //
// src/App.vue